module.exports = __webpack_public_path__ + "img/news_list_5.1aa7d1c1.jpg";